// WebSocketService.ts
import { BaseRequest } from "./types/BaseRequest";
import { Player } from "services/Account/types/Player";


class WebSocketService {
  private socket: WebSocket;

  constructor(roomId: string, url: string, onMessage: (message: any) => void, player: Player) {

    this.socket = new WebSocket(url);

    this.socket.onopen = () => {
      this.socket.send(JSON.stringify({ type: "join", room_id: roomId, player: player }));
    };
    this.socket.onmessage = (event) => onMessage(JSON.parse(event.data));
    this.socket.onclose = () => console.log("WebSocket connection closed.");
  }

  sendMessage<T extends BaseRequest>(message: T) {
    this.socket.send(JSON.stringify(message));
  }

  closeConnection() {
    this.socket.close();
  }
  
}

export default WebSocketService;
